import { Box, Tabs, Tab } from '@mui/material';
const DetailPanel = ({ activeTab, onTabChange, children }) => (
	<Box sx={{ width: '100%' }}>
		<Box sx={{ borderBottom: 1, borderColor: 'divider', mb: 3 }}>
			<Tabs
				value={activeTab}
				onChange={onTabChange}
				variant="scrollable">
				<Tab label='OVERVIEW' />
				<Tab label='ATTENDANCE' />
				<Tab label='BOOKING' />
				<Tab label='LOGBOOK' />
				<Tab label='HANDOVER' />
			</Tabs>
		</Box>
		{children}
	</Box>
);

export default DetailPanel;
